import React, { useState } from 'react';

import * as authActions from 'global/actions/authActions';
import { useActions } from 'hooks/useActions';
import { Input } from 'user/components';
import { Header, Body, Footer, FooterButton } from 'components/Modals/modalElements';

// Get fragment with modal sign in functionality
export default function ModalContentTwoFactor({ onCancel }) {
  const { loginTwoFactor } = useActions(authActions);

  const [twoFactorCode, setTwoFactorCode] = useState('');

  const onEnterTwoFactor = (e) => e.key === 'Enter' && twoFactorCode && loginTwoFactor(twoFactorCode, true);

  return (
    <>
      <Header>Two Factor</Header>
      <Body>
        <Input
          type="text"
          autoFocus
          value={twoFactorCode}
          placeholder="Enter two factor authentication code"
          onChange={(e) => setTwoFactorCode(e.target.value)}
          onKeyDown={onEnterTwoFactor}
        />
      </Body>
      <Footer>
        <FooterButton onClick={onCancel} label="Cancel" />
        <FooterButton onClick={() => loginTwoFactor(twoFactorCode, true)} label="Confirm" disabled={!twoFactorCode} />
      </Footer>
    </>
  );
}
